import { YOLLAR } from './yonlendirme';
import { BOLUM_ADI, KABUK_METIN } from './metin/kabuk';
import { PZ } from './metin/seo';
import { type MenuIkonAdi } from './menu-ikonlar';
import { PZ_SEKMELER, sekmeGorunur, type PzSekme } from './pazarlama-durum';

export interface MenuMaddesi {
  readonly yol: string;
  readonly etiket: string;
  /** Geciken is sayisi; etikete yazilmaz, rozet olarak cizilir. */
  readonly sayi?: number;
}
export interface MenuOgesi extends MenuMaddesi { ikon: MenuIkonAdi }
interface Tanim { yol: string; ikon: MenuIkonAdi; etiket?: string; sekme?: PzSekme }
/** Eski menu useMemo'su izinli yolları sağlar; ek sekmeler de burada aynı koşulla süzülür. */
const TABLO: readonly { ad: string; etiket: string; ikon: MenuIkonAdi; yol?: string; ogeler: readonly Tanim[] }[] = [
  { ad: 'genel', etiket: KABUK_METIN.gezinme.genelBakis, ikon: 'ev', ogeler: [{ yol: YOLLAR.genelBakis, ikon: 'ev' }] },
  { ad: 'satis', etiket: BOLUM_ADI.SALES!, ikon: 'satis', yol: YOLLAR.satis, ogeler: [
    { yol: YOLLAR.satis, ikon: 'satis', etiket: KABUK_METIN.gezinme.bolumSatis }, { yol: YOLLAR.musteriler, ikon: 'musteri' }, { yol: YOLLAR.turBilgi, ikon: 'form' }, { yol: YOLLAR.otelTeklif, ikon: 'otel' }, { yol: YOLLAR.hizliTeklif, ikon: 'hizli' }, { yol: YOLLAR.v3, ikon: 'web' },
  ] },
  { ad: 'operasyon', etiket: BOLUM_ADI.OPERATIONS!, ikon: 'operasyon', yol: YOLLAR.operasyon, ogeler: [
    { yol: YOLLAR.operasyon, ikon: 'operasyon', etiket: KABUK_METIN.gezinme.bolumOperasyon }, { yol: YOLLAR.tedarikciler, ikon: 'tedarik' }, { yol: YOLLAR.belgeler, ikon: 'form' },
  ] },
  { ad: 'finans', etiket: BOLUM_ADI.FINANCE!, ikon: 'finans', yol: YOLLAR.finans, ogeler: [{ yol: YOLLAR.finans, ikon: 'finans' }] },
  { ad: 'pazarlama', etiket: BOLUM_ADI.MARKETING!, ikon: 'pazarlama', yol: YOLLAR.pazarlama, ogeler: PZ_SEKMELER.map((sekme) => {
    const ikonlar: Record<typeof sekme, MenuIkonAdi> = { genel: 'genel', kampanya: 'kampanya', 'geri-kazanim': 'geri', riza: 'riza', seo: 'seo', ai: 'ai' };
    return { yol: `${YOLLAR.pazarlama}?sekme=${sekme}`, ikon: ikonlar[sekme], etiket: sekme === 'genel' ? KABUK_METIN.gezinme.bolumPazarlama : PZ[sekme], sekme };
  }) },
  { ad: 'yonetim', etiket: KABUK_METIN.gezinme.yonetim, ikon: 'ayar', ogeler: [
    { yol: YOLLAR.ik, ikon: 'ik' }, { yol: YOLLAR.denetim, ikon: 'denetim' }, { yol: YOLLAR.yapilandirma, ikon: 'ayar' },
  ] },
];
export function menuGruplari(menu: readonly MenuMaddesi[], izinler: readonly string[]) {
  return TABLO.flatMap((grup) => {
    const bolum = menu.find((m) => m.yol === grup.yol);
    const ogeler: MenuOgesi[] = grup.ogeler.flatMap((t) => {
      if (grup.ad === 'pazarlama') {
        if (!bolum || (t.sekme !== undefined && !sekmeGorunur(t.sekme, izinler))) return [];
        return [{ yol: t.yol, etiket: t.etiket!, ikon: t.ikon, ...(t.sekme === 'genel' && bolum.sayi ? { sayi: bolum.sayi } : {}) }];
      }
      const izinli = menu.find((m) => m.yol === t.yol);
      return izinli ? [{ ...izinli, ...(t.etiket ? { etiket: t.etiket } : {}), ikon: t.ikon }] : [];
    });
    const ilk = ogeler[0];
    if (!ilk) return [];
    let hedef: MenuOgesi = ilk;
    if (bolum) hedef = { ...bolum, ikon: grup.ikon };
    else if (ogeler.length > 1 && grup.ad !== 'yonetim') hedef = { ...ilk, etiket: grup.etiket, ikon: grup.ikon };
    return [{ ad: grup.ad, etiket: grup.etiket, ogeler, hedef, baslik: hedef.etiket }];
  });
}
